export function rm(value: number | null | undefined, currency = "RM"): string {
  if (value == null) return "—";
  return `${currency} ${value.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function credits(value: number | null | undefined): string {
  if (value == null) return "—";
  return `${value.toLocaleString("en-MY", { maximumFractionDigits: 2 })} cr`;
}

export function timeAgo(date: string | Date): string {
  const ms = Date.now() - new Date(date).getTime();
  const mins = Math.floor(ms / 60_000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export function fmtDate(date: string | Date | null | undefined): string {
  if (!date) return "—";
  return new Date(date).toLocaleString("en-MY", {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** DD/MM/YYYY — used for FlexxiPlan and Vault dates. */
export function fmtDateDMY(date: string | Date | null | undefined): string {
  if (!date) return "—";
  return new Date(date).toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
}

/** DD/MM/YYYY HH:mm */
export function fmtDateTimeDMY(date: string | Date | null | undefined): string {
  if (!date) return "—";
  const d = new Date(date);
  const time = d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false });
  return `${fmtDateDMY(d)} ${time}`;
}

/** Orders list: weekday + dd-mm-yyyy */
export function fmtOrderListDate(date: string | Date | null | undefined): string {
  if (!date) return "—";
  const d = new Date(date);
  const weekday = d.toLocaleDateString("en-MY", { weekday: "long" });
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${weekday}, ${dd}-${mm}-${yyyy}`;
}

export function countdownParts(target: string | Date): { d: number; h: number; m: number; s: number; done: boolean } {
  const diff = new Date(target).getTime() - Date.now();
  if (diff <= 0) return { d: 0, h: 0, m: 0, s: 0, done: true };
  return {
    d: Math.floor(diff / 86_400_000),
    h: Math.floor((diff / 3_600_000) % 24),
    m: Math.floor((diff / 60_000) % 60),
    s: Math.floor((diff / 1000) % 60),
    done: false,
  };
}

export function idemKey(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}
